import React from 'react';
import BlankPageTemplate from '../Templates/BlankPageTemplate';
import ContainerFluid from '../ThemeComponents/grid/ContainerFluid';
import Row from '../ThemeComponents/grid/Row';
import Col from '../ThemeComponents/grid/Col';

const NotFound = () => {
  return (
    <BlankPageTemplate title="Not Found">
      <ContainerFluid>
        <Row>
          <Col cols="col-12">
            <p className="mb-0">The page you are looking for does not exist.</p>
          </Col>
        </Row>
      </ContainerFluid>
    </BlankPageTemplate>
  );
};

export default NotFound;
